// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {createSelector} from 'reselect';

export const actionStatusSelector = createSelector(
    (state): any => state,
    res => (action: string) => res.actionStatus[action] || { status: 0 }
);
